/**
 * IvCert
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';
import { InlineResponse200 } from '../model/inlineResponse200';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { DateParser } from "../date";
import { PersonalizationsService } from '../../base/services/personalizations/personalizations.service';
import { Environment } from '../../models/environment';

@Injectable()
export class AuthService {

    environment: Environment;
    protected basePath: string;
    public defaultHeaders = new HttpHeaders().set('timeClient', DateParser.parse(new Date()));
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration, private _personalization: PersonalizationsService) {
        this.environment = this._personalization.sendEnv;
        this.basePath = this.environment?.url_api;
        this.defaultHeaders = this.defaultHeaders.set('X-Request-ID', 'app-front');
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    /**
     *
     *
     * @param grant_type Valor &#39;refresh_token&#39; para refrescar el que esté a punto de caducar
     * @param callbackId CallbackId de la elección del certificado
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAuthAuthCertPost(grant_type: string, callbackId: string, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse200>;
    public apiAuthAuthCertPost(grant_type: string, callbackId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse200>>;
    public apiAuthAuthCertPost(grant_type: string, callbackId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse200>>;
    public apiAuthAuthCertPost(grant_type: string, callbackId: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (grant_type === null || grant_type === undefined) {
            throw new Error('Required parameter grant_type was null or undefined when calling apiAuthAuthCertPost.');
        }

        if (callbackId === null || callbackId === undefined) {
            throw new Error('Required parameter callbackId was null or undefined when calling apiAuthAuthCertPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void | HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        if (grant_type !== undefined) {
            formParams = formParams.append('grant_type', <any>grant_type) || formParams;
        }
        if (callbackId !== undefined) {
            formParams = formParams.append('callbackId', <any>callbackId) || formParams;
        }

        return this.httpClient.post<InlineResponse200>(`${this.basePath}/api/Auth/AuthCert`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param grantType Valor &#39;refresh_token&#39; para refrescar el que esté a punto de caducar
     * @param authOperation Operation authentication
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOperationAuthOperationPost(grantType: string, authOperation: string, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse200>;
    public apiOperationAuthOperationPost(grantType: string, authOperation: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse200>>;
    public apiOperationAuthOperationPost(grantType: string, authOperation: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse200>>;
    public apiOperationAuthOperationPost(grantType: string, authOperation: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (grantType === null || grantType === undefined) {
            throw new Error('Required parameter grantType was null or undefined when calling apiOperationAuthOperationPost.');
        }

        if (authOperation === null || authOperation === undefined) {
            throw new Error('Required parameter authOperation was null or undefined when calling apiOperationAuthOperationPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        if (grantType !== undefined) {
            formParams = formParams.append('grant_type', <any>grantType) || formParams;
        }
        if (authOperation !== undefined) {
            formParams = formParams.append('authOperation', <any>authOperation) || formParams;
        }

        return this.httpClient.post<InlineResponse200>(`${this.basePath}/api/Operation/AuthOperation`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param grantType Valor &#39;refresh_token&#39; para refrescar el que esté a punto de caducar
     * @param username
     * @param password
     * @param appId Identificador de la personalización
     * @param urlCallback
     * @param cifCompany CIF de la empresa
     * @param refreshToken Valor de &#39;refresh_token&#39; obtenido en el login.
     * @param orgaId IvSign organization id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mfaTokenPost(grantType: string, username: string, password: string, appId: string, urlCallback?: string, cifCompany?: string, refreshToken?: string, orgaId?: string, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse200>;
    public mfaTokenPost(grantType: string, username: string, password: string, appId: string, urlCallback?: string, cifCompany?: string, refreshToken?: string, orgaId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse200>>;
    public mfaTokenPost(grantType: string, username: string, password: string, appId: string, urlCallback?: string, cifCompany?: string, refreshToken?: string, orgaId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse200>>;
    public mfaTokenPost(grantType: string, username: string, password: string, appId: string, urlCallback?: string, cifCompany?: string, refreshToken?: string, orgaId?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (grantType === null || grantType === undefined) {
            throw new Error('Required parameter grantType was null or undefined when calling mfaTokenPost.');
        }

        if (username === null || username === undefined) {
            throw new Error('Required parameter username was null or undefined when calling mfaTokenPost.');
        }

        if (password === null || password === undefined) {
            throw new Error('Required parameter password was null or undefined when calling mfaTokenPost.');
        }

        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling mfaTokenPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void | HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        if (grantType !== undefined) {
            formParams = formParams.append('grant_type', <any>grantType) || formParams;
        }
        if (username !== undefined) {
            formParams = formParams.append('username', <any>username) || formParams;
        }
        if (password !== undefined) {
            formParams = formParams.append('password', <any>password) || formParams;
        }
        if (urlCallback !== undefined) {
            formParams = formParams.append('urlCallback', <any>urlCallback) || formParams;
        }
        if (appId !== undefined) {
            formParams = formParams.append('appId', <any>appId) || formParams;
        }
        if (cifCompany !== undefined) {
            formParams = formParams.append('cifCompany', <any>cifCompany) || formParams;
        }
        if (refreshToken !== undefined) {
            formParams = formParams.append('refresh_token', <any>refreshToken) || formParams;
        }
        if (orgaId !== undefined) {
            formParams = formParams.append('orgaId', <any>orgaId) || formParams;
        }

        return this.httpClient.post<InlineResponse200>(`${this.basePath}/mfaToken`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param grantType Valor &#39;refresh_token&#39; para refrescar el que esté a punto de caducar
     * @param username
     * @param password
     * @param appId Identificador de la personalización
     * @param cifCompany CIF de la empresa
     * @param typeLogin Tipo de autentificación
     * @param refreshToken Valor de &#39;refresh_token&#39; obtenido en el login. Debe ir conjuntamente con &#39;grant_type&#39; &#x3D; &#39;password&#39;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tokenPost(grantType: string, username: string, password: string, appId: string, cifCompany?: string, typeLogin?: string, refreshToken?: string, orgaId?: string, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse200>;
    public tokenPost(grantType: string, username: string, password: string, appId: string, cifCompany?: string, typeLogin?: string, refreshToken?: string, orgaId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse200>>;
    public tokenPost(grantType: string, username: string, password: string, appId: string, cifCompany?: string, typeLogin?: string, refreshToken?: string, orgaId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse200>>;
    public tokenPost(grantType: string, username: string, password: string, appId: string, cifCompany?: string, typeLogin?: string, refreshToken?: string, orgaId?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (grantType === null || grantType === undefined) {
            throw new Error('Required parameter grantType was null or undefined when calling tokenPost.');
        }

        if (username === null || username === undefined) {
            throw new Error('Required parameter username was null or undefined when calling tokenPost.');
        }

        if (password === null || password === undefined) {
            throw new Error('Required parameter password was null or undefined when calling tokenPost.');
        }

        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling tokenPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any); };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        if (grantType !== undefined) {
            formParams = formParams.append('grant_type', <any>grantType) || formParams;
        }
        if (username !== undefined) {
            formParams = formParams.append('username', <any>username) || formParams;
        }
        if (password !== undefined) {
            formParams = formParams.append('password', <any>password) || formParams;
        }
        if (appId !== undefined) {
            formParams = formParams.append('appId', <any>appId) || formParams;
        }
        if (cifCompany !== undefined) {
            formParams = formParams.append('cifCompany', <any>cifCompany) || formParams;
        }
        if (typeLogin !== undefined) {
            formParams = formParams.append('typeLogin', <any>typeLogin) || formParams;
        }
        if (refreshToken !== undefined) {
            formParams = formParams.append('refresh_token', <any>refreshToken) || formParams;
        }

        if (orgaId !== undefined) {
            formParams = formParams.append('orgaId', <any>orgaId) || formParams;
        }

        return this.httpClient.post<InlineResponse200>(`${this.basePath}/token`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param grantType Valor &#39;refresh_token&#39; para refrescar el que esté a punto de caducar
     * @param appId Identificador de la personalización
     * @param giveToken Test parameter (it will get deleted)
     * @param transactionId
     * @param pretoken
     * @param refreshToken Valor de &#39;refresh_token&#39; obtenido en el login.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public validateMfaTokenPost(grantType: string, appId: string, transactionId: string, pretoken: string, refreshToken?: string, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse200>;
    public validateMfaTokenPost(grantType: string, appId: string, transactionId: string, pretoken: string, refreshToken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse200>>;
    public validateMfaTokenPost(grantType: string, appId: string, transactionId: string, pretoken: string, refreshToken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse200>>;
    public validateMfaTokenPost(grantType: string, appId: string, transactionId: string, pretoken: string, refreshToken?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (grantType === null || grantType === undefined) {
            throw new Error('Required parameter grantType was null or undefined when calling validateMfaTokenPost.');
        }

        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling validateMfaTokenPost.');
        }

        if (transactionId === null || transactionId === undefined) {
            throw new Error('Required parameter transactionId was null or undefined when calling validateMfaTokenPost.');
        }

        if (pretoken === null || pretoken === undefined) {
            throw new Error('Required parameter pretoken was null or undefined when calling validateMfaTokenPost.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void | HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        if (grantType !== undefined) {
            formParams = formParams.append('grant_type', <any>grantType) || formParams;
        }
        if (appId !== undefined) {
            formParams = formParams.append('appId', <any>appId) || formParams;
        }
        if (transactionId !== undefined) {
            formParams = formParams.append('transactionId', <any>transactionId) || formParams;
        }
        if (pretoken !== undefined) {
            formParams = formParams.append('pretoken', <any>pretoken) || formParams;
        }
        if (refreshToken !== undefined) {
            formParams = formParams.append('refresh_token', <any>refreshToken) || formParams;
        }

        return this.httpClient.post<InlineResponse200>(`${this.basePath}/validateMfaToken`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
